import type { ButtonHTMLAttributes, FC } from "react";
import { HeartIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/button";
import { cn } from "@/lib/cn";

type FavoriteButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  active?: boolean;
  iconClassName?: string;
};

export const FavoriteButton: FC<FavoriteButtonProps> = ({ active, className, iconClassName, ...props }) => (
  <Button
    type="button"
    variant="icon"
    size="s"
    aria-label="Save practitioner"
    aria-pressed={active}
    className={cn("size-32 p-0", className)}
    icon={<HeartIcon className={cn(active ? "fill-brand-red text-brand-red" : "text-neutral-black", iconClassName)} />}
    {...props}
  />
);
